import React, { createContext, useState, useContext } from 'react';

const AgentAuthContext = createContext();

export const useAgentAuth = () => useContext(AgentAuthContext);

export const AgentAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [agentData, setAgentData] = useState(() => {
        const storedAgent = localStorage.getItem("agent");
        return storedAgent ? JSON.parse(storedAgent) : null;
    });

  return (
    <AgentAuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, agentData, setAgentData }}>
      {children}
    </AgentAuthContext.Provider>
  );
};
